import { consoleRequest } from '@/console/api/http'
import { WorkflowRestartRequest, WorkflowRestartResponse } from '@/console/api/types'

/**
 * 워크플로 restart(LOGISPRD-15715, moms-be PR #4886). 성공 본문에 `meta` 래퍼가 없어(규약 B) 그대로 돌려준다.
 *
 * 동기 호출이다. 서버는 cancel 단계 30초 · 종료 대기 60초 · 재시작 단계 30초 상한을 차례로 쓰고 돌아온다. 전역 axios
 * timeout(100000ms)보다 길어 이 호출에만 5분을 건다. 재시도하지 않는다 — 응답을 놓치면 같은 조건으로 다시 불러 확인한다
 * (서버가 같은 run 의 재제출을 겹쳐 시작하지 않는다).
 */
const BASE = '/api/v1/workflow/restarts'

export const WORKFLOW_RESTART_TIMEOUT_MS = 5 * 60 * 1000

export const requestWorkflowRestart = (request: WorkflowRestartRequest): Promise<WorkflowRestartResponse> =>
  consoleRequest.post<WorkflowRestartResponse, WorkflowRestartRequest>(BASE, request, { timeout: WORKFLOW_RESTART_TIMEOUT_MS })
